import "../scss/style.scss";
import "./home.js";
import "./products.js";
import objectFitImages from 'object-fit-images';
import 'jquery-match-height';
import 'lity';

jQuery(function ($) {

  // smooth scroll
  $(function(){
    // anchorlink
    var urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        var speed = 500;
        var target = $(urlHash);
        if(window.matchMedia("(min-width:768px)").matches){
          var position_pc_a = target.offset().top - 94;
          $("html, body").animate({scrollTop:position_pc_a}, speed, "swing");
        }
        else {
          var position_sp_a = target.offset().top - 70;
          $("html, body").animate({scrollTop:position_sp_a}, speed, "swing");
        }
      }, 50);
    }
    $('a[href^="#"]').click(function(){
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      if(window.matchMedia("(min-width:768px)").matches){
        var position_pc = target.offset().top - 94;
        $("html, body").animate({scrollTop:position_pc}, speed, "swing");
      }
      else {
        var position_sp = target.offset().top - 70;
        $("html, body").animate({scrollTop:position_sp}, speed, "swing");
      }
      return false;
    });
  });

  // SP menu
  $(function(){
    $('.js-nav-btn').on('click',function(){
      $(".js-nav").fadeToggle();
      $(this).toggleClass('is-close');
    });
    $('.js-nav a[href^="#"], .js-nav-overlay').on('click',function(){
      $(".js-nav").fadeOut();
      $('.js-nav-btn').removeClass('is-close');
    });
  });

  // pagetop
  $(function(){
    $(window).scroll(function () {
      if($(this).scrollTop() >= 300) {
        $('.js-pagetop').fadeIn();
      } else {
        $('.js-pagetop').fadeOut();
      }
    });
  });

  // header fixed side scroll
  $(window).on("scroll", function(){
    $(".js-header").css("left", -$(window).scrollLeft());
  });

  // year acordion
  $(function(){
    $('.js-year-btn').on('click',function(){
      $('+ .js-year-content', this).slideToggle();
    });
    $('.js-year-content a').on('click',function(){
      $(this).parents('.js-year-content').slideUp();
    });
  });

  // object-fit
  $(function () {
    objectFitImages('.js-objectfit-img');
  });

});